export default __webpack_public_path__ + "static/web/media/omnichannel-customer-expectations.e94594ac.jpg";